export const generalQuestions = [
  {
    id: '1',
    title: 'What is included in my free plan?',
    answer:
      'Free Plan includes 100 Export Credits as well as to view the first 25 results of any search results.',
  },
  {
    id: '2',
    title: 'Do you offer discounts?',
    answer: 'Yes. You can save 20% for all up-front annual payments.',
  },
  {
    id: '3',
    title: 'How many export credits do I get?',
    answer:
      'You get 100 export credits during your Free Trial and 10,000 when you upgrade to Basic.',
  },
  {
    id: '4',
    title: 'What is your minimum price?',
    answer: 'Our pricing starts from $245 USD per month.',
  },
];

export const creditsPricingQuestions = [
  {
    id: '1',
    title: 'Do you offer free trial?',
    answer:
      'Yes. Testing AI Ark’s capabilities and how it can benefit your business for free or until your initial credits runs out.',
  },
  {
    id: '2',
    title: 'How are AI Ark’s packages structured?',
    answer:
      'AI Ark has a flexible SaaS-based pricing model personalized for each client based on the number of user licenses and level of data access and features required.',
  },
  {
    id: '3',
    title: 'Is AI Ark different from Sales Navigator?',
    answer:
      'AI Ark is a helpful tool to build customer and prospect lists quickly and efficiently, with advanced filtering options.',
  },
  {
    id: '4',
    title:
      'What’s the difference between export credits and verified email credits?',
    answer:
      'Export credits at AI Ark allow you to choose whether to export data related to companies or individual contacts. If you require verified and fresh email addresses for these contacts, you can enhance your export credits with verified email credits. This ensures that the email data you access is not only up-to-date but also validated for accuracy.',
  },
  {
    id: '5',
    title: 'Will I be charged at the end of my free trial?',
    answer:
      'No. If you reach the end of your free trial, just contact us at sales@ai-ark.io we will help you choose the right top-up package.',
  },
  {
    id: '6',
    title: 'What does one export credit cover at AI Ark?',
    answer:
      'One export credit at AI Ark provides complete information on a company or a contact within the company, helping you make informed business decisions.',
  },
  {
    id: '7',
    title: 'What happens if I exceed my allocated credits?',
    answer:
      'If you find yourself nearing your limit and need additional credits, simply contact our Customer Success Team. They will assist you in selecting the appropriate top-up package to ensure you continue receiving the data you need without interruption.',
  },
];

export const billingQuestions = [
  {
    id: '1',
    title: 'What is an Export Credit?',
    answer:
      'Export Credit is all the information we have on a single company or contact from that company. You will incur export credits if you decide to export or download a contact as a CSV file.',
  },
  {
    id: '2',
    title: 'What does it mean "unused Credits Roll over"?',
    answer:
      'Any unused credits over one billing period are carried over to the next cycle.',
  },
  {
    id: '3',
    title: 'How long are your contracts?',
    answer: 'All our contracts are either monthly or annual basis.',
  },
  {
    id: '4',
    title: 'What is included in my trial plans?',
    answer:
      'Free Trial includes 100 Export Credits and viewership of the first 25 filter results. You also have access to 17+ features of the platform.',
  },
  {
    id: '5',
    title: 'Can I cancel, upgrade, or downgrade my AI Ark plan at any time?',
    answer:
      'You can manage your subscription through your billing settings in the app. Changes will take effect at the end of the current plan cycle for cancellations and downgrades, while upgrades will be implemented immediately.',
  },
];
